export const getCookieValue = (cookieName: string) => {
    const value = `; ${document.cookie}`;
    return value
        .split(';')
        .map(cookieValue => cookieValue.split('='))
        .find(([key]) => key.replace(' ', '') === cookieName)
        ?.slice(1)
        .join('=');
};
